<template>
    <v-container fluid>
    <v-row no-gutters justify="space-between">
    <h2 class="text-h4">{{ $t('dashboard.title') }}</h2>
    <v-select dense style="max-width:200px" v-model="period" :items="periods" @change="loadStats(false)" append-outer-icon="$refresh" @click:append-outer="loadStats(false)" />
    </v-row>
    <template v-if="item">
        <v-banner single-line elevation="10" color="warning" icon="$warn" v-if="isIncomplete">
            {{ $t('dashboard.incomplete') }}
            <template v-slot:actions>
            <v-btn
                text
                :to="{name: 'domain-overview'}"
            >
            {{ $t('dashboard.settings')}}
            </v-btn>
            </template>
        </v-banner>
        
        <v-banner dark single-line elevation="10" color="error" icon="$warn" v-else-if="isCancelled">
            {{ $t('dashboard.inactive') }}
            <template v-slot:actions>
            <v-btn
                text
                :to="{name: 'domain-overview'}"
            >
            {{ $t('dashboard.settings')}}
            </v-btn>
            </template>
        </v-banner>
        
        <v-banner single-line elevation="10" color="warning" icon="$warn" v-else-if="!hasRecommendations">
            {{ $t('dashboard.noProducts') }}
            <template v-slot:actions>
            <v-btn
                text
                :to="{name: 'domain-overview'}"
            >
            {{ $t('dashboard.settings')}}
            </v-btn>
            </template>
        </v-banner>
        <v-row>
        <v-col cols="12" md="6">
        <sales-card
            id="pfid1618853377" 
            :height="380"
            :chartHeight="215"
            class="h-full"
            :label="$t('dashboard.sales.all')"
            :value="totalSales"
            :value-count="totalCount"
            :count-suffix="$t('dashboard.orders.suffix')"
            :loading="loading"
            :percentage-label="null /* $t('dashboard.lastWeek') */"
            dark
            :currency="item.currency"
            :xaxis="xaxis"
            :series="totalSeries"
        ></sales-card>
        </v-col>
        <v-col cols="12" md="6">
                <sources-card id="pfid1618853386" style="height:100%" :label="$t('dashboard.sources')" :loading="loading" :data="sources" />
        </v-col>
        <v-col cols="12" md="6">
            <sales-card
                    id="pfid1618853391" 
                    :height="280"
                    :chart-height="115"
                    :label="$t('dashboard.sales.webboxes')"
                    :value="webboxSales"
                    :value-count="webboxCount"
                    :count-suffix="$t('dashboard.orders.suffix')"
                    :loading="loading"
                    :currency="item.currency"
                    :xaxis="xaxis"
                    :series="webboxSeries"
            ></sales-card>
        </v-col>
        <v-col cols="12" md="6">
            <sales-card
                    id="pfid1618853397" 
                    :height="280"
                    :chart-height="115"
                    :label="$t('dashboard.sales.email')"
                    :value="emailSales"
                    :value-count="emailCount"
                    :count-suffix="$t('dashboard.orders.suffix')"
                    :loading="loading"
                    :currency="item.currency"
                    :xaxis="xaxis"
                    :series="emailSeries"
                ></sales-card>
        </v-col>
        <v-col cols="12" md="6">
            <sales-card
                    id="pfid1618853407" 
                    :height="280"
                    :chart-height="115"
                    :label="$t('dashboard.sales.sms')"
                    :value="smsSales"
                    :value-count="smsCount"
                    :count-suffix="$t('dashboard.orders.suffix')"
                    :loading="loading"
                    :currency="item.currency"
                    :xaxis="xaxis"
                    :series="smsSeries"
                    coming-soon
                ></sales-card>
        </v-col>
        <v-col cols="12" md="6">
            <sales-card
                    id="pfid1618853413" 
                    :height="280"
                    :chart-height="115"
                    :label="$t('dashboard.sales.push')"
                    :value="pushSales"
                    :value-count="pushCount"
                    :count-suffix="$t('dashboard.orders.suffix')"
                    :loading="loading"
                    :currency="item.currency"
                    :xaxis="xaxis"
                    :series="pushSeries"
                    coming-soon
                ></sales-card>
            </v-col>
            <v-col cols="12">
                <v-card id="pfid1618853425" >
                    <v-card-title>{{$t('dashboard.leadscore.title')}}</v-card-title>
                    <v-list>
                        <v-list-item>
                            <v-list-item-icon><tooltip-icon color="blue" tooltip="COLD" icon="$leadscoreCold"/></v-list-item-icon>
                            <v-list-item-content>
                            <v-list-item-subtitle>COLD: 0% - {{item.leadscoringSettings.segments[1].percentile}}%</v-list-item-subtitle>
                            <v-list-item-title>{{ item.leadscoringSettings.segments[0].visitors - item.leadscoringSettings.segments[1].visitors }} {{$t('dashboard.leadscore.visitors')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><tooltip-icon color="orange" tooltip="WARM" icon="$leadscoreWarm"/></v-list-item-icon>
                            <v-list-item-content>
                            <v-list-item-subtitle>WARM: {{item.leadscoringSettings.segments[1].percentile}}% - {{item.leadscoringSettings.segments[2].percentile}}%</v-list-item-subtitle>
                            <v-list-item-title>{{ item.leadscoringSettings.segments[1].visitors - item.leadscoringSettings.segments[2].visitors }} {{$t('dashboard.leadscore.visitors')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><tooltip-icon color="red" tooltip="HOT" icon="$leadscoreHot"/></v-list-item-icon>
                            <v-list-item-content>
                            <v-list-item-subtitle>HOT: {{item.leadscoringSettings.segments[2].percentile}}% - 100%</v-list-item-subtitle>
                            <v-list-item-title>{{ item.leadscoringSettings.segments[2].visitors }} {{$t('dashboard.leadscore.visitors')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
    </template>
    <v-row v-else>
        <v-col cols="12" md="6" v-for="i in [0,1,2,3,4,5,6,7]" :key="i">
            <v-skeleton-loader type="card" class="mb-1"/>
        </v-col>
    </v-row>
    
    </v-container>
</template>
<script>

import SalesCard from '@/components/dashboard/SalesCard'
import SourcesCard from '@/components/dashboard/SourcesCard'
import { mapState, mapGetters } from 'vuex'


export default {
    name: 'DomainDashboard',
    components: {SalesCard, SourcesCard},
    data() {
        return {
            loading: false,
            period: '7d',
            periods: ['7d','14d','21d','1m','3m','6m','12m'].map(p => { return { text: this.$t(`common.periods.${p}`), value: p}}),
            /*
            [
                { text: 'Last 7 days', value: '7d' },
                { text: 'Last 14 days', value: '14d' },
                { text: 'Last 21 days', value: '21d' },
                { text: 'Last month', value: '1m' },
                { text: 'Last 3 months', value: '3m' },
                { text: 'Last 6 months', value: '6m' },
                { text: 'Last 12 months', value: '12m' },
            ],
            */
        }
    },
    computed: {
        mediaLookup() {
            let output = {};
            this.itemStats.data.media.forEach((m, i) => {output[m.category] = i});
            return output;
        },
        xaxis() {
            if(!this.itemStats) {
                return null;
            }
            return {
                type: 'datetime',
                categories: this.itemStats.data.days.map(r => `${r.day}T00:00:00.000Z`)
            }
        },
        totalSales() {
            return this.itemStats?.data.total.sales;
        },
        totalCount() {
            return  this.itemStats?.data.total.orders;
        },
        totalSeries() {
            return [
                {
                    name: this.$t('dashboard.sales.all'),
                    data: this.itemStats?.data.days.map(d => d.media.reduce((total, m) => m.sales + total, 0))
                },
                {
                    name: this.$t('dashboard.orders.title'),
                    data: this.itemStats?.data.days.map(d => d.media.reduce((total, m) => m.orders + total, 0))
                }
            ]},
        sources() {
            return [
                { title: this.$t('media.webboxes'), value: this.itemStats?.data.media[this.mediaLookup['WEBBOX']].sales, color:'#2364aa' },
                { title: this.$t('media.email'), value: this.itemStats?.data.media[this.mediaLookup['EMAIL']].sales, color:'#3da5d9'}, 
                { title: this.$t('media.push'), value: this.itemStats?.data.media[this.mediaLookup['PUSH']].sales, color:'#73bfb8'}, 
                { title: this.$t('media.sms'), value: this.itemStats?.data.media[this.mediaLookup['SMS']].sales, color:'#fec601'}, 
            ]
        },
        emailSales() {
            return this.itemStats?.data.media[this.mediaLookup['EMAIL']].sales;
        },
        emailCount() {
            return this.itemStats?.data.media[this.mediaLookup['EMAIL']].orders;
        },
        emailSeries() {
                return [
                {
                    name: this.$t('dashboard.sales.all'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['EMAIL']].sales)
                },
                {
                    name: this.$t('dashboard.orders.title'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['EMAIL']].orders)
                }
        ]},
        webboxSales() {
            return this.itemStats?.data.media[this.mediaLookup['WEBBOX']].sales;
        },
        webboxCount() {
            return this.itemStats?.data.media[this.mediaLookup['WEBBOX']].orders;
        },
        webboxSeries() {
            return [
                {
                    name: this.$t('dashboard.sales.all'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['WEBBOX']].sales)
                },
                {
                    name: this.$t('dashboard.orders.title'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['WEBBOX']].orders)
                }
            ]},
        pushSales() {
            return this.itemStats?.data.media[this.mediaLookup['PUSH']].sales;
        },
        pushCount() {
            return this.itemStats?.data.media[this.mediaLookup['PUSH']].orders;
        },
        pushSeries() {
            return [
                {
                    name: this.$t('dashboard.sales.all'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['PUSH']].sales)
                },
                {
                    name: this.$t('dashboard.orders.title'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['PUSH']].orders)
                }
            ]},
        smsSales() {
            return this.itemStats?.data.media[this.mediaLookup['SMS']].sales;
        },
        smsCount() {
            return this.itemStats?.data.media[this.mediaLookup['SMS']].orders;
        },
        smsSeries() {
                return [
                {
                    name: this.$t('dashboard.sales.all'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['SMS']].sales)
                },
                {
                    name: this.$t('dashboard.orders.title'),
                    data: this.itemStats?.data.days.map(d => d.media[this.mediaLookup['SMS']].orders)
                }
        ]},
        ...mapState('domains', ['item','itemStats']),
        ...mapGetters('domains', [ 'isCancelled', 'isIncomplete', 'hasRecommendations'])
    },
    methods: {
        loadStats(allowCache) {
            if(this.item) {
                this.loading = true;
                this.$store.dispatch('domains/getStats', { id: this.item.id, period: this.period, allowCache}).then(() => {
                    this.loading = false;
                })
            }
        },
    },
    watch: {
        item() {
            if(this.item && !this.itemStats) {
            //console.debug('Loading stats - watch');
            //console.dir(val);
            this.loadStats(true);
        }
    }
  },
    created() {
        if(this.item && !this.itemStats) {
            console.debug('Loading stats - create');
            this.loadStats(true);
        }
    }
}
</script>